import React from 'react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

const AppCaptionStyles = styled(UiTypography)<{
  withBg: boolean;
}>`
  line-height: 11px;

  ${({ withBg }) =>
    withBg &&
    `
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.10);
    backdrop-filter: blur(5px);
    will-change: backdrop-filter, background;
    padding: 10px;
  `}
`;

export const AppCaption: React.FC<{
  withBg?: boolean;
  variant?: 'default' | 'white';
}> = ({ withBg = false, variant = 'default' }) => {
  return (
    <AppCaptionStyles
      variant="label-small"
      color={variant === 'white' ? 'white' : 'white-static'}
      withBg={withBg}
    >
      by Pheon
    </AppCaptionStyles>
  );
};
